import { Directive, Input, TemplateRef, ViewContainerRef } from '@angular/core';

import { UserAuthService } from '../services/user-auth.sevice';
import { UserPermission } from '../store/state/auth-user';
import { featureName, moduleName, operationName } from '../constant/user-role-constant';

export interface Permission {

    //Referral Management Permissions
    referralManagementCreate: "referralManagementCreate";
    referralManagementEdit: "referralManagementEdit";
    referralManagementView: "referralManagementView";
    referralManagementDelete: "referralManagementDelete";
    referralManagementAll: "referralManagementAll";
}

@Directive({
    selector: '[appReferralPermission]'
})

export class ReferralPermissionDirective {
    constructor(
        private templateRef: TemplateRef<any>,
        private viewContainer: ViewContainerRef,
        private userAuthService: UserAuthService
    ) { }

    @Input('appReferralPermission') set appReferralHasPermission(permissionKeys: (keyof Permission)[] | keyof Permission) {

        const permissionsArray = Array.isArray(permissionKeys) ? permissionKeys : [permissionKeys];
        const permissionSets: UserPermission[] = [];

        permissionsArray.forEach(permissionKey => {
            const mappedPermissions = this.mapPermission(permissionKey);
            permissionSets.push(...mappedPermissions);
        });
        const hasPermission = this.userAuthService.hasPermission(permissionSets);
        if (hasPermission) {
            this.viewContainer.createEmbeddedView(this.templateRef);
        } else {
            this.viewContainer.clear();
        }
    }

    private mapPermission(permissionKey: keyof Permission): UserPermission[] {
        const permissionMappings: Record<keyof Permission, UserPermission> = {
            referralManagementCreate: { moduleName: moduleName.referral, featureName: featureName.patientReferral, operationName: operationName.create },
            referralManagementEdit: { moduleName: moduleName.referral, featureName: featureName.patientReferral, operationName: operationName.write },
            referralManagementView: { moduleName: moduleName.referral, featureName: featureName.patientReferral, operationName: operationName.view },
            referralManagementDelete: { moduleName: moduleName.referral, featureName: featureName.patientReferral, operationName: operationName.delete },
            referralManagementAll: { moduleName: moduleName.referral, featureName: featureName.patientReferral, operationName: operationName.all },
        };

        const permission = permissionMappings[permissionKey];
        return permission ? [permission] : [];
    }

}